<template>
  <div>
    <van-popup
      class="popup"
      v-model="show"
      position="bottom"
      :style="{ padding: '1.88rem 0' }"
      @close="close"
    >
      <div @click="goBaiDu">百度地图</div>
      <div @click="goGaoDe">高德地图</div>
    </van-popup>
  </div>
</template>
<script>
import bridge from "@/common/bridge";

// 百度经纬度转高德
let x_pi = (3.14159265358979324 * 3000.0) / 180.0;
function ba_gd(bd_lat, bd_lon) {
  let x = Number(bd_lon - 0.0065);
  let y = Number(bd_lat - 0.006);
  let z = Number(Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi));
  let theta = Number(Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi));
  bd_lon = Number(z * Math.cos(theta));
  bd_lat = Number(z * Math.sin(theta));
  return {
    lat: bd_lat,
    lng: bd_lon,
  };
}
export default {
  model: {
    prop: "show",
    event: "update",
  },
  props: {
    show: Boolean,
    to: Object,
  },
  methods: {
    goBaiDu: function () {
      let ua = navigator.userAgent;
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let data = {
        ...this.to,
      };
      if (ua.indexOf("AliApp") > -1) {
        this.$dialog.alert({
          message:
            "当前系统不支持使用导航功能，如需导航，请到“鹿路通”APP使用本应用",
        });
      } else if (
        ua.toLowerCase().match(/MicroMessenger/i) == "micromessenger"
      ) {
        this.$dialog.alert({
          message:
            "当前系统不支持使用导航功能，如需导航，请到“鹿路通”APP使用本应用",
        });
      } else {
        if (isiOS) {
          bridge.callhandler("goBaiDuMap", data, (data) => {
            console.log(data);
          });
        }
        if (isAndroid) {
          // setLngAndLat为H5调用原生的函数名,包括传递给原生的参数
          var str = JSON.parse(
            window.ServiceAddrInterface.goBaiDuMap(
              data.lat,
              data.lng,
              data.name
            )
          );
        }
      }
    },
    goGaoDe: function () {
      let parmas = ba_gd(this.to.lat, this.to.lng);

      let ua = navigator.userAgent;
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let data = {
        name: this.to.name,
        ...parmas,
      };
      if (ua.indexOf("AliApp") > -1) {
        this.$dialog.alert({
          message:
            "当前系统不支持使用导航功能，如需导航，请到“鹿路通”APP使用本应用",
        });
      } else if (
        ua.toLowerCase().match(/MicroMessenger/i) == "micromessenger"
      ) {
        this.$dialog.alert({
          message:
            "当前系统不支持使用导航功能，如需导航，请到“鹿路通”APP使用本应用",
        });
      } else {
        if (isiOS) {
          bridge.callhandler("goGaoDeMap", data, (data) => {
            console.log(data);
          });
        }
        if (isAndroid) {
          console.log("跳转高德地图", data.lat, data.lng, data.name);
          window.ServiceAddrInterface.goGaoDeMap(data.lat, data.lng, data.name);
        }
      }
    },
    close() {
      //   this.show = false;
      this.$emit("update", false);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .popup > div {
  height: 6.5rem;
  line-height: 6.5rem;
  font-size: 2rem;
  color: #555555;
  text-align: center;
}
</style>